import {
  MOON_500,
  TEAL_500,
  TEAL_600,
} from '@wandb/weave/common/css/globals.styles';
// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon as NewIcon} from '@wandb/weave/components/Icon';
// eslint-disable-next-line wandb/no-deprecated-imports
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

import {GLOBAL_COLORS} from '../../../../util/colors';
import {Banner, BannerBoldText} from '../../../Banner';
import {InlineMarkdownEditor} from '../../../elements/InlineMarkdownEditor';

export const BannerWithMargin = styled(Banner)`
  margin-top: 24px;
  margin-bottom: 16px;
  padding-right: 24px;
`;
BannerWithMargin.displayName = 'S.BannerWithMargin';

export const BannerWithMarginVersion = styled(Banner)`
  margin-top: 8px;
  margin-bottom: 16px;
  padding-right: 24px;
`;
BannerWithMargin.displayName = 'S.BannerWithMarginVersion';

export const PointerBoldText = styled(BannerBoldText)`
  cursor: pointer;
`;
PointerBoldText.displayName = 'S.PointerBoldText';

export const OverviewWrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
  overflow-y: auto;
  // Hide scrollbars
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;
OverviewWrapper.displayName = 'S.OverviewWrapper';

export const OverviewPanel = styled.div`
  min-width: 50px;
  flex: 1 0 50px;
  height: 100%;
`;
OverviewPanel.displayName = 'S.OverviewPanel';

export const OverviewItem = styled.div`
  display: flex;
  min-height: 36px;
  align-items: top;
  flex: 1 1 auto;
  width: 100%;
`;
OverviewItem.displayName = 'S.OverviewItem';

export const OverviewKey = styled.div`
  flex: 0 0 166px;
  color: ${GLOBAL_COLORS.lightGray.toString()};
`;
OverviewKey.displayName = 'S.OverviewKey';

export const OverviewValue = styled.div`
  flex: 1 1 auto;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* margin-right: 35px; */

  .copyable-text {
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .artifact-add-alias-button {
    height: 26px;
    width: 26px;
    text-align: center;
    margin: 0;
    color: ${GLOBAL_COLORS.gray.toString()};
    font-size: 18px;
    padding: 0px;
  }
`;
OverviewValue.displayName = 'S.OverviewValue';

export const OverviewValueMarkdownEditor = styled(InlineMarkdownEditor)`
  white-space: normal;
  cursor: pointer;
`;
OverviewValueMarkdownEditor.displayName = 'S.OverviewValueMarkdownEditor';

export const OverviewPanelSectionBodyColumn = styled.div`
  flex: 1 1 100px;
  width: 100px;
`;
OverviewPanelSectionBodyColumn.displayName = 'S.OverviewPanelSectionBodyColumn';

export const OverviewPanelSectionBodyRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;
OverviewPanelSectionBodyRow.displayName = 'S.OverviewPanelSectionBodyRow';

export const OverviewPanelSectionBody = styled.div`
  border: 1px solid #e0e0e0;
  padding: 0.5em;
  border-radius: 5px;
`;
OverviewPanelSectionBody.displayName = 'S.OverviewPanelSectionBody';

export const OverviewPanelSection = styled.div``;
OverviewPanelSection.displayName = 'S.OverviewPanelSection';

export const OverviewPanelSectionHeaderTitle = styled.div`
  display: flex;
  align-items: center;
  font-size: 1.2em;
  font-weight: 500;
  .ui.button {
    margin-left: 15px;
  }
`;
OverviewPanelSectionHeaderTitle.displayName =
  'S.OverviewPanelSectionHeaderTitle';

export const OverviewPanelSectionHeader = styled.div`
  position: sticky;
  top: 0;
  z-index: 2;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  line-height: 32px;
  margin-bottom: 12px;
`;
OverviewPanelSectionHeader.displayName = 'S.OverviewPanelSectionHeader';

export const OverviewPanelTagOrAliasContainer = styled.div`
  display: flex;
  max-height: 84px;
  overflow-y: auto;
  margin-bottom: 8px;
  margin-left: -2px;
`;
OverviewPanelTagOrAliasContainer.displayName =
  'S.OverviewPanelTagOrAliasContainer';

export const SettingsOverviewText = styled.div<{
  mainText?: boolean;
  size?: 'small' | 'medium';
}>`
  ${(props: any) => (props.mainText ? `` : `color: ${MOON_500};`)}
  font-weight: 400;
  font-size: ${(props: any) => (props.size === 'medium' ? '20px' : '16px')};
  line-height: 22px;
  margin-bottom: 8px;
`;
SettingsOverviewText.displayName = 'S.SettingsOverviewText';

export const SettingsOverview = styled.div`
  display: inline-flex;
  align-content: center;
  line-height: 22px;
`;
SettingsOverview.displayName = 'S.SettingsOverview';

export const ClickableText = styled.div`
  margin-left: 4px;
  color: ${TEAL_600};
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  cursor: pointer;
  &:hover {
    color: ${TEAL_500};
  }
`;
ClickableText.displayName = 'S.ClickableText';

export const IntegrationOverview = styled.div`
  max-width: 50px;
  margin: 10px 0px;
  display: flex;
`;
IntegrationOverview.displayName = 'S.IntegrationOverview';

export const EmptyTriggersTable = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 240px;
  border: 1px solid #e0e0e0;
  align-items: center;
  border-radius: 5px;
`;
EmptyTriggersTable.displayName = 'S.EmptyTriggersTable';

export const TriggerContainer = styled.div`
  display: inline-flex;
  margin-left: auto;
`;
TriggerContainer.displayName = 'S.TriggerContainer';

export const StyledIcon = styled(NewIcon)`
  margin-right: 4px;
  vertical-align: middle;
`;
StyledIcon.displayName = 'S.StyledIcon';

export const SuccessfulLink = styled.div`
  display: flex;
  align-items: center;
`;
SuccessfulLink.displayName = 'S.SuccessfulLink';

export const SuccessfulLinkMessage = styled.div`
  margin-left: 8px;
`;
SuccessfulLinkMessage.displayName = 'S.SuccessfulLinkMessage';

export const StyledLink = styled.a`
  color: ${TEAL_500};
  font-weight: 600;
`;
StyledLink.displayName = 'S.StyledLink';
